export default {
  en: {
    driveThru: 'Drive-Thru',
    kvs: 'KVS',
    mcdelivery: 'McDelivery',
    mcdeliveryAnalysis: 'McDelivery Analysis',
    kiosk: 'Kiosk',
    // ServiceTimeStats
    'highlighted-rows': '* Highlighted rows have 1 or more bad quarter hours that have been masked and WILL NOT be included in any calculations due to bad data received from the POS',
    'premium-upgrade-message-start': 'Organizations that reward shifts for hitting OEPE targets have seen a 20 second improvement.',
    'premium-upgrade-message-link-text': 'Upgrade to Premium',
    'premium-upgrade-message-end': ' to get started with Rewards.',
    'service-time-stats': 'Service Time Statistics',
    'DT': 'DT',
    'FC': 'FC',
    'MFY': 'MFY',
    'KVS': 'KVS',
    'Bev': 'Bev',
    'service-time-stats-analysis': 'Service Time Stats Analysis',
    // MOPServiceTimes
    'mop-service-times': 'MOP Service Times',
    'grid-footer': '* Ready On Arrival(ROA) orders that were sent to the POS while customer was traveling to the restaurant.',
    'curbside': 'Curbside',
    'table-side': 'Table Side',
    'int-delivery': 'Integrated McDelivery',
    // voice
    'voice-report-warning': 'To set up the email import for VOICE Comments, please follow the instructions',
    'here': 'here',
    // dtTimer
    'dt-timer': 'DT Timer',
    // YYNN
    'YY': 'Y / Y',
    'YN': 'Y / N',
    'NY': 'N / Y',
    'NN': 'N / N',
    'YY_DESC': 'OEPE Down, Guest Counts Up',
    'YN_DESC': 'OEPE Down, Guest Counts Down',
    'NY_DESC': 'OEPE Up, Guest Counts Up',
    'NN_DESC': 'OEPE Up, Guest Counts Down',
    // MatrixGrid
    'matrix-grid-name': 'Drive Thru YY NN Matrix',
    'weekly-trend': 'Weekly Trend',
    // DifferenceGrid
    'weekly-yot': 'Weekly YoY DT Performance',
    'current': 'Current',
    'previous': 'Previous',
    // YYNNChart
    'DT-trend': 'Drive Thru YY/NN Trend',
    // CustomerFeedback
    'customer-feedback': 'Customer Feedback',
    // SpeedOfService
    'speed-of-service': 'Speed of Service',
    'drive-thru': 'Drive-Thru',
    'front-counter': 'Front Counter',
    'mfy1': 'MFY1',
    'mfy2': 'MFY2',
    'beverage': 'Beverage',
  },
  es: {
    driveThru: 'Autoservicio',
    kvs: 'KVS',
    mcdelivery: 'McDelivery',
    mcdeliveryAnalysis: 'Análisis de McDelivery',
    kiosk: 'Quiosco',
    // ServiceTimeStats
    'highlighted-rows': '* Las filas resaltadas tienen 1 o más cuartos de hora incorrectos que se han enmascarado y NO se incluirán en ningún cálculo debido a los datos incorrectos recibidos del POS.',
    'premium-upgrade-message-start': 'Las organizaciones que recompensan los turnos por alcanzar los objetivos de OEPE han visto una mejora de 20 segundos.',
    'premium-upgrade-message-link-text': 'Actualiza a Premium',
    'premium-upgrade-message-end': ' para comenzar con Recompensas.',
    'service-time-stats': 'Estadísticas de Tiempo de Servicio',
    'DT': 'DT',
    'FC': 'FC',
    'MFY': 'MFY',
    'KVS': 'KVS',
    'Bev': 'Bev',
    'service-time-stats-analysis': 'Análisis de Estadísticas de Tiempo de Servicio',
    // MOPServiceTimes
    'mop-service-times': 'Tiempos de Servicio MOP',
    'grid-footer': '* Las órdenes Ready On Arrival (ROA) que se enviaron al POS mientras el cliente viajaba al restaurante.',
    'curbside': 'Servicio en la Curbside',
    'table-side': 'Lado de la Mesa',
    'int-delivery': 'McDelivery Integrado',
    // voice
    'voice-report-warning': 'Para configurar la importación de correo electrónico para los comentarios de VOICE, siga las instrucciones',
    'here': 'aquí',
    // dtTimer
    'dt-timer': 'Minutero DT',
    // YYNN
    'YY': 'Y / Y',
    'YN': 'Y / N',
    'NY': 'N / Y',
    'NN': 'N / N',
    'YY_DESC': 'OEPE a la baja, conteo de clientes al alza',
    'YN_DESC': 'OEPE a la baja, conteo de clientes a la baja',
    'NY_DESC': 'OEPE al alza, conteo de clientes al alza',
    'NN_DESC': 'OEPE al alza, conteo de clientes a la baja',
    // MatrixGrid
    'matrix-grid-name': 'Matriz YY NN de Drive Thru',
    'weekly-trend': 'Tendencia Semanal',
    // DifferenceGrid
    'weekly-yot': 'Rendimiento semanal DT interanual',
    'current': 'Actual',
    'previous': 'Anterior',
    // YYNNChart
    'DT-trend': 'Tendencia DT YY/NN',
    // CustomerFeedback
    'customer-feedback': 'Comentarios del Cliente',
    // SpeedOfService
    'speed-of-service': 'Velocidad de Servicio',
    'drive-thru': 'Autoservicio',
    'front-counter': 'Mostrador',
    'mfy1': 'MFY1',
    'mfy2': 'MFY2',
    'beverage': 'Bebidas',
  },
};
